// @flow

import type { EasyAction } from '../../type'

import * as React from 'react'

type Props = {
  convertId: string
};

export default class Inmobi extends React.PureComponent<Props> {
  static actions: EasyAction[] = [
    {
      title: '记录点击事件',
      name: 'pushEvent'
    }
  ];

  componentWillMount () {
    loadAdCode()
  }

  actionPushEvent = (data: void) => {
    fireEvent('download', 'download')
  };

  render () {
    return null
  }
}

function fireEvent (eventType, eventName) {
  var PROPERTY_ID = 'cf819a3f31fb43098c41bb2d46ec8956'
  var PING_SERVER_URL =
    'https://advertiser.inmobiapis.cn/tpce/v1/events/' +
    eventType +
    '?trackingPartner=InMobi&country=CN'
  var pageData = {}
  if (typeof window.InmobiPixel !== 'undefined') {
    window.inmobiPixel = new window.InmobiPixel()
    window.inmobiPixel.init({
      pingServer: PING_SERVER_URL,
      propertyId: PROPERTY_ID,
      domain: 'fengjr.com'
    })
  }
  window.inmobiPixel.ping(eventName, pageData)
}

function fireCustomEvent (eventName) {
  fireEvent('custom', eventName)
}

var scrollFired = false

// $FlowFixMe
function scrollEventHandler () {
  // $FlowFixMe
  var h =
    window.document.documentElement.scrollTop ||
    window.pageYOffset ||
    window.document.body.scrollTop
  var minScrollHeight = 100
  if (!scrollFired && h >= minScrollHeight) {
    scrollFired = true
    fireCustomEvent('fengjr_scroll')
  }
}

function _debounce (func, wait, immediate) {
  var timeout, args, context, timestamp, result
  var later = function () {
    var last = Date.now() - timestamp
    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }
  return function () {
    context = this
    args = arguments
    timestamp = Date.now()
    var callNow = immediate && !timeout
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }
    return result
  }
}

function loadAdCode () {
  /* eslint-disable */

  // $FlowFixMe
  var fireScrollEvent = _debounce(scrollEventHandler, 300);
  window.document.body.addEventListener('scroll', fireScrollEvent, true);

  var ta = document.createElement('script');
  ta.type = 'text/javascript';
  ta.async = true;
  ta.src = 'https://inmobi.oss-cn-hangzhou.aliyuncs.com/pixel/inmobipixel.js';
  ta.onload = function() {
    fireCustomEvent('fengjr_lp');
  };
  var s = document.getElementsByTagName('script')[0];
  // $FlowFixMe
  s.parentNode.insertBefore(ta, s);

  /* eslint-enable */
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/plugin/NewInmobi.js